<template>
  <v-navigation-drawer
    expand-on-hover
    permanent
    rail
    color="#0D1321"
    elevation="2"
  >
    <!-- Brand -->
    <div class="sidebar-brand">
      <v-avatar size="36" color="primary" rounded="lg">
        <v-icon color="white" size="20">mdi-school</v-icon>
      </v-avatar>
      <div class="brand-text ml-2">
        <div class="brand-name">GCK Admin</div>
        <div class="brand-sub">Management Portal</div>
      </div>
    </div>

    <v-divider color="rgba(255,255,255,0.08)" />

    <!-- Admin info -->
    <div class="sidebar-user">
      <v-avatar size="32" color="primary" class="flex-shrink-0">
        <span class="text-white" style="font-size:0.7rem;font-weight:700;">
          {{ ($store.state.adminDetails.name || 'A').charAt(0).toUpperCase() }}
        </span>
      </v-avatar>
      <div class="user-text ml-2">
        <div class="user-name">{{ $store.state.adminDetails.name || 'Admin' }}</div>
        <div class="user-role">{{ $store.state.adminRole || 'Staff' }}</div>
      </div>
    </div>

    <v-divider color="rgba(255,255,255,0.08)" />

    <!-- Nav items -->
    <v-list density="compact" nav class="mt-1 sidebar-nav">
      <v-list-item to="/" :active="$route.path === '/'" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-view-dashboard-outline</v-icon></template>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>

      <div class="nav-section-label">Content</div>

      <v-list-item to="/departments" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-book-open-variant-outline</v-icon></template>
        <v-list-item-title>Departments</v-list-item-title>
      </v-list-item>

      <v-list-item to="/event" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-image-multiple-outline</v-icon></template>
        <v-list-item-title>Event Gallery</v-list-item-title>
      </v-list-item>

      <v-list-item to="/banners" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-image-area</v-icon></template>
        <v-list-item-title>Banners</v-list-item-title>
      </v-list-item>

      <v-list-item to="/circulars" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-file-document-outline</v-icon></template>
        <v-list-item-title>Circulars</v-list-item-title>
      </v-list-item>

      <div class="nav-section-label">Academic</div>

      <v-list-item to="/non_teaching" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-account-tie-outline</v-icon></template>
        <v-list-item-title>Non-Teaching Staff</v-list-item-title>
      </v-list-item>

      <v-list-item to="/scholarships" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-medal-outline</v-icon></template>
        <v-list-item-title>Scholarships</v-list-item-title>
      </v-list-item>

      <v-list-item to="/iqac" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-clipboard-check-outline</v-icon></template>
        <v-list-item-title>IQAC</v-list-item-title>
      </v-list-item>

      <v-list-item to="/pdfs" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-file-cabinet</v-icon></template>
        <v-list-item-title>General PDFs</v-list-item-title>
      </v-list-item>

      <v-list-item to="/criteria" class="nav-item" rounded="lg">
        <template #prepend><v-icon size="18">mdi-paperclip</v-icon></template>
        <v-list-item-title>DVV Criteria</v-list-item-title>
      </v-list-item>

      <template v-if="$store.state.adminRole === 'Super Admin'">
        <div class="nav-section-label">Super Admin</div>
        <v-list-item to="/app-menus" class="nav-item" rounded="lg">
          <template #prepend><v-icon size="18">mdi-menu</v-icon></template>
          <v-list-item-title>App Menus</v-list-item-title>
        </v-list-item>
        <v-list-item to="/admins" class="nav-item" rounded="lg">
          <template #prepend><v-icon size="18">mdi-shield-account-outline</v-icon></template>
          <v-list-item-title>Manage Admins</v-list-item-title>
        </v-list-item>
      </template>

      <v-divider color="rgba(255,255,255,0.08)" class="my-2" />

      <v-list-item @click="logout()" class="nav-item nav-item-logout" rounded="lg">
        <template #prepend><v-icon size="18">mdi-logout</v-icon></template>
        <v-list-item-title>Log Out</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  methods: {
    logout () {
      sessionStorage.removeItem('token')
      this.$store.state.isAuthenticated = false
      this.$router.push('/login')
    },
  },
}
</script>

<style scoped>
/* Brand row */
.sidebar-brand {
  display: flex;
  align-items: center;
  padding: 14px 12px;
  min-height: 56px;
}
.brand-name { font-size: 0.82rem; font-weight: 800; color: #fff; line-height: 1.2; white-space: nowrap; }
.brand-sub  { font-size: 0.62rem; color: rgba(255,255,255,0.45); white-space: nowrap; }

/* User row */
.sidebar-user {
  display: flex;
  align-items: center;
  padding: 10px 12px;
}
.user-name { font-size: 0.78rem; font-weight: 700; color: #fff; white-space: nowrap; }
.user-role { font-size: 0.62rem; color: rgba(255,255,255,0.5); white-space: nowrap; }

/* Nav */
.sidebar-nav { padding: 0 8px; }
.nav-section-label {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.3);
  padding: 12px 12px 4px;
  white-space: nowrap;
  overflow: hidden;
}
.nav-item { margin-bottom: 2px; color: rgba(255,255,255,0.65) !important; }
.nav-item:hover { background: rgba(255,255,255,0.06) !important; color: #fff !important; }
.nav-item.v-list-item--active { background: rgba(255,255,255,0.1) !important; color: #fff !important; }
.nav-item-logout { color: rgba(255,100,100,0.75) !important; margin-top: 2px; }
.nav-item-logout:hover { background: rgba(255,80,80,0.08) !important; color: #ff6b6b !important; }
</style>
